

// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // Evita eventos extras ao detectar sessão na URL
  },
  realtime: {
    // Web Worker para heartbeat resistente a throttling de aba background
    // Navegadores reduzem timers JS em abas inativas, matando o heartbeat normal.
    // Web Worker roda em thread separada e NÃO sofre esse throttling.
    worker: true,
    // Callback para reconectar automaticamente quando heartbeat detecta desconexão.
    // Quando o servidor mata o WebSocket por falta de heartbeat, este callback
    // força reconexão do transporte inteiro (não apenas do canal).
    heartbeatCallback: (status: string) => {
      if (status === 'disconnected') {
        supabase.realtime.connect();
      }
    },
  },
});
